// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/users-and-teams/records/TeamUser.ts
import { Record } from 'immutable';
export default Record({
  userId: 0,
  routableUser: false
}, 'TeamUser');